import { render, staticRenderFns } from "./DiadocDocument.vue?vue&type=template&id=4a90757b"
import script from "./DiadocDocument.vue?vue&type=script&lang=js"
export * from "./DiadocDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports